import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useGenesis } from "@/hooks/useGenesis";
import { GenesisToken } from "@/components/genesis/GenesisToken";
import { StatusChip, BuyButton } from "@/components/genesis/GenesisBits";

// Balance page card. Informational + link to the official provider — no wallet interaction, no signatures.
export function GenesisBalanceCard() {
  const navigate = useNavigate();
  const { data, status } = useGenesis({ tick: false });
  const buy = data?.purchase_link_enabled && status !== "ended";
  return (
    <div data-testid="balance-genesis" className="relative mt-2 overflow-hidden rounded-2xl border border-am-border bg-am-surface2 p-4">
      <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full aura-radial opacity-20 blur-2xl" />
      <div className="relative flex items-center gap-3">
        <GenesisToken size={48} parallax={false} className="shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2 text-sm font-bold text-white">AURAMAX GENESIS {status && <StatusChip status={status} />}</div>
          <div className="text-xs text-am-text2">{buy ? "Join the presale on the official provider, or read the terms first." : "Explore the official Genesis offering and its terms."}</div>
        </div>
        <button onClick={() => navigate("/genesis")} data-testid="balance-genesis-view" className="flex shrink-0 items-center gap-0.5 text-xs font-semibold text-white hover:underline">View Genesis <ChevronRight className="h-4 w-4 text-am-text3" /></button>
      </div>
      {buy && <div className="relative mt-3"><BuyButton data={data} status={status} size="sm" testid="balance-genesis-buy" surface="balance" className="w-full" /></div>}
    </div>
  );
}
